import {VisaFormConfig} from './forms';

export interface Visa {}

export const VISA_ARRIVAL_FORM_CONFIG: VisaFormConfig = {};
